import axios from 'axios';

import {
    APPLE_PAY_GET_SESSION,
    APPLE_PAY_GET_SESSION__FAILURE,

    APPLE_PAY_VALIDATE_MERCHANT,
    APPLE_PAY_VALIDATE_MERCHANT__SUCCESS,
    APPLE_PAY_VALIDATE_MERCHANT__FAILURE,

    APPLE_PAY_PAYMENT_AUTHORIZED,
    APPLE_PAY_PAYMENT_AUTHORIZED__FAILURE,

    APPLE_PAY__RESET,
} from './actions';

function getApplePaySessionStart() {
    return {
        type: APPLE_PAY_GET_SESSION,
    };
}


function getApplePaySessionFailure(error) {
    return {
        type: APPLE_PAY_GET_SESSION__FAILURE,
        error,
    };
}

function getApplePayValidateMerchant() {
    return {
        type: APPLE_PAY_VALIDATE_MERCHANT,
    };
}

function getApplePayValidateMerchantSuccess(data) {
    return {
        type: APPLE_PAY_VALIDATE_MERCHANT__SUCCESS,
        data,
    };
}

function getApplePayValidateMerchantFailure(error) {
    return {
        type: APPLE_PAY_VALIDATE_MERCHANT__FAILURE,
        error,
    };
}

function getApplePayAuthorize() {
    return {
        type: APPLE_PAY_PAYMENT_AUTHORIZED,
    };
}


function getApplePayAuthorizeFailure(error) {
    return {
        type: APPLE_PAY_PAYMENT_AUTHORIZED__FAILURE,
        error,
    };
}

function getApplePayReset(error) {
    return {
        type: APPLE_PAY__RESET,
        error,
    };
}

const validateMerchant = (dispatch, token) => axios.post(
    `${process.env.REACT_APP_API_URL}${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/v1/pay/getApplePaySession/${token}`,
    { headers: { 'Content-Type': 'application/json' } },
).then(response => {
    if (response.status === 200 && response.data) {
        const {
            data: {
                error,
                errorMessage,
            },
        } = response;
        if (error || errorMessage) {
            return {
                error: error || errorMessage,
            };
        }
        return response.data;
    }
    return {
        error: 'Ошибка сервера',
    };
})
    .catch(error => {
        dispatch(getApplePayValidateMerchantFailure(new Error(error)));
    });

const makeApplePay = (dispatch, { token, paymentData }) => axios.post(
    `${process.env.REACT_APP_API_URL}${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/v1/pay/makeApplePay/${token}`,
    {
        data: {
            paymentData: JSON.stringify(paymentData),
        },
    }, {
        headers: { 'Content-Type': 'application/json' },
    },
).then(response => {
    if (response.status === 200 && response.data) {
        const {
            data: {
                error,
                errorMessage,
            },
        } = response;
        if (error || errorMessage) {
            return {
                error: error || errorMessage,
            };
        }
        return response.data;
    }
    return {
        error: 'Ошибка сервера',
    };
})
    .catch(error => {
        dispatch(getApplePayAuthorizeFailure(new Error(error)));
    });

export function getApplePaySession({ amount, orderId }) {
    return (dispatch) => {
        dispatch(getApplePaySessionStart());
        dispatch(getApplePayValidateMerchant());
        const url = document.location.href;
        const parsedUrl = new URL(url);
        const token = parsedUrl.pathname.replace(
            `${process.env.PUBLIC_URL || process.env.REACT_APP_PUBLIC_URL}/pay/`, '',
        );

        const request = {
            countryCode: 'RU',
            currencyCode: 'RUB',
            merchantCapabilities: [
                'supports3DS',
            ],
            lineItems: [
                {
                    type: 'final',
                    label: 'Сумма платежа',
                    amount: parseFloat(amount),
                },
            ],
            supportedNetworks: [
                'visa',
                'masterCard',
                'mir',
            ],
            total: {
                label: `Заказ #${orderId}`,
                type: 'final',
                amount: parseFloat(amount),
            },
        };
        const session = new window.ApplePaySession(3, request);

        // Create ApplePaySession
        session.onvalidatemerchant = async () => {
            const merchantSession = await validateMerchant(dispatch, token);
            if (merchantSession.error) {
                dispatch(getApplePaySessionFailure(merchantSession.error));
            } else {
                dispatch(getApplePayValidateMerchantSuccess(merchantSession));
                session.completeMerchantValidation(merchantSession);
            }
        };

        session.onpaymentauthorized = async ({ payment }) => {
            // Define ApplePayPaymentAuthorizationResult
            const { paymentData } = payment.token;
            dispatch(getApplePayAuthorize());

            const data = {
                paymentData,
                token,
            };

            if (process.env.REACT_APP_ENV === 'DEV' || process.env.REACT_APP_ENV === 'TEST') {
                console.log('apple payment', { payment });
                console.log('apple paymentData', data);
            }

            const { status, redirectURL } = await makeApplePay(dispatch, data);

            if (redirectURL && ((status === 1) || (status === 2))) {
                const result = {
                    status: window.ApplePaySession.STATUS_SUCCESS,
                };
                session.completePayment(result);
                window.location.href = redirectURL;
            }
        };

        session.oncancel = () => {
            // Payment cancelled by WebKit
            dispatch(getApplePayReset());
        };

        session.begin();
    };
}
